module.exports = __webpack_public_path__ + "static/media/306.ce9a6b0f.webp";